export default __webpack_public_path__ + "static/media/misc-books1-1920w.5fadff6d.avif";